import * as actions from './actions'
import * as effects from './effects'
import { state } from './state'

export default { actions, state, effects }
